import {BrowserRouter, Navigate, Route, Routes} from "react-router";
import {AuthProvider} from "./auth/AuthContext";
import {ThemeProvider} from "./theme/ThemeContext";
import {RequireAuth} from "./auth/RequireAuth";
import {RequireAdmin} from "./auth/RequireAdmin";
import {SiteLayout} from "./layout/SiteLayout";
import {AdminLayout} from "./layout/AdminLayout";
import {HomePage} from "./pages/HomePage";
import {LoginPage} from "./pages/LoginPage";
import {ForgotPasswordPage} from "./pages/ForgotPasswordPage";
import {ResetPasswordPage} from "./pages/ResetPasswordPage";
import {VerifyEmailPage} from "./pages/VerifyEmailPage";
import {NotFoundPage} from "./pages/NotFoundPage";
import {ProfilePage} from "./pages/account/ProfilePage";
import {MyLicensesPage} from "./pages/account/MyLicensesPage";
import {UsersPage} from "./pages/admin/UsersPage";
import {LicensesPage} from "./pages/admin/LicensesPage";
import {LicenseDetailPage} from "./pages/admin/LicenseDetailPage";

export function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<SiteLayout/>}>
                            <Route index element={<HomePage/>}/>
                            <Route path="login" element={<LoginPage/>}/>
                            <Route path="forgot-password" element={<ForgotPasswordPage/>}/>
                            {/* The API's emails link to these two. */}
                            <Route path="reset-password" element={<ResetPasswordPage/>}/>
                            <Route path="verify-email" element={<VerifyEmailPage/>}/>

                            <Route element={<RequireAuth/>}>
                                <Route path="account">
                                    <Route index element={<Navigate to="profile" replace/>}/>
                                    <Route path="profile" element={<ProfilePage/>}/>
                                    {/* TSA-1's licence dialog links here (TSA1_LICENSE_PORTAL). */}
                                    <Route path="licenses" element={<MyLicensesPage/>}/>
                                </Route>
                                <Route path="admin" element={<RequireAdmin/>}>
                                    <Route element={<AdminLayout/>}>
                                        <Route index element={<Navigate to="users" replace/>}/>
                                        <Route path="users" element={<UsersPage/>}/>
                                        <Route path="licenses" element={<LicensesPage/>}/>
                                        <Route path="licenses/:licenseId" element={<LicenseDetailPage/>}/>
                                    </Route>
                                </Route>
                            </Route>

                            <Route path="*" element={<NotFoundPage/>}/>
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
